import { lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { CookieConsent } from '@/components/CookieConsent.tsx'

const LandingPage = lazy(() => import('@/pages/LandingPage.tsx').then(m => ({ default: m.LandingPage })))
const PricingPage = lazy(() => import('@/pages/PricingPage.tsx').then(m => ({ default: m.PricingPage })))
const BlogPage = lazy(() => import('@/pages/BlogPage.tsx').then(m => ({ default: m.BlogPage })))
const BlogArticlePage = lazy(() => import('@/pages/BlogArticlePage.tsx').then(m => ({ default: m.BlogArticlePage })))
const ROICalculatorPage = lazy(() => import('@/pages/ROICalculatorPage.tsx').then(m => ({ default: m.ROICalculatorPage })))
const PrivacyPolicyPage = lazy(() => import('@/pages/PrivacyPolicyPage.tsx').then(m => ({ default: m.PrivacyPolicyPage })))
const TermsPage = lazy(() => import('@/pages/TermsPage.tsx').then(m => ({ default: m.TermsPage })))
const NotFoundPage = lazy(() => import('@/pages/NotFoundPage.tsx').then(m => ({ default: m.NotFoundPage })))

function RouteFallback() {
  return (
    <div className="flex h-screen items-center justify-center">
      <svg className="animate-spin h-6 w-6 text-primary" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
      </svg>
    </div>
  )
}

export default function App() {
  return (
    <BrowserRouter>
      <CookieConsent />
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/blog" element={<BlogPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/roi" element={<ROICalculatorPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}
